import angular from 'angular';
import utils from '@/shared/utils/adminpulse';
import { dynamicSort, dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular
  .module('cxSettings')
  .controller('ImportTaskTemplateSnippetDialogCtrl', [
    'flySvc',
    'translateListFilter',
    'data',
    '$element',
    'close',
    'appUrls',
    '$http',
    'templateHttpSvc',
    'dataCache',
    'resourceNameFilter',
    '$q',
    '$translate',
    importTaskTemplateSnippetDialogCtrl,
  ]);

function importTaskTemplateSnippetDialogCtrl(
  flySvc,
  translateListFilter,
  data,
  $element,
  close,
  appUrls,
  $http,
  templateHttpSvc,
  dataCache,
  resourceNameFilter,
  $q,
  $translate,
) {
  var vm = this;
  vm.data = data;

  vm.hasMails = !!data.mailTemplates && data.mailTemplates.length > 0;
  vm.hasParameters = !!data.taskParameters && data.taskParameters.length > 0;
  vm.hasPeriodicities = !!data.taskPeriodicities && data.taskPeriodicities.length > 0;
  vm.hasWorkflows = !!data.workflows && data.workflows.length > 0;
  vm.hasTimeResources = !!data.timeResources && data.timeResources.length > 0;
  vm.hasCostResources = !!data.costResources && data.costResources.length > 0;
  vm.hasUsers = !!data.users && data.users.length > 0;
  vm.saving = false;
  vm.showValidation = false;
  vm.mailTemplates = [];
  vm.mailTemplateActions = (vm.data.mailTemplates || []).map(x => ({
    ...x,
    canImport: !!x.originalId,
    action: x.originalId ? 'import' : '',
  }));
  vm.users = dataCache
    .getArray('user')
    .filter(x => x.isActive)
    .map(function(user) {
      return {
        id: user.userID,
        name: ((user.firstName || '') + ' ' + (user.lastName || '')).trim(),
      };
    })
    .sort(dynamicSort('name'));

  vm.model = {
    documentId: data.documentId,
    taskTemplateName: data.templateName,
    importMailTemplates: vm.hasMails,
    importPeriodicities: vm.hasPeriodicities,
    importTaskParameters: vm.hasParameters,
    importWorkflows: true,
    timeResources: data.timeResources,
    costResources: data.costResources,
    users: data.users.map(x => {
      const matchingUser = x.originalId ? vm.users.find(u => u.id === x.originalId) : null;

      return {
        ...x,
        snippetImportId: matchingUser ? matchingUser.id : null,
      };
    }),
  };

  if (vm.hasMails) {
    templateHttpSvc.getTemplates(11).then(function(data) {
      vm.mailTemplates = data.map(x => ({
        ...x,
        label: translateListFilter(x.id, 'template', x.name),
      }));

      vm.mailTemplateActions.forEach(x => {
        if (x.originalId) {
          //Match by id, should only work if same tenant
          const mailTemplate = vm.mailTemplates.find(r => r.id === x.originalId);
          if (mailTemplate) {
            x.action = `r;${mailTemplate.id}`;
            return;
          }
        }
        if (!x.name) return;
        //Match by name
        const mailTemplate = vm.mailTemplates.find(
          r => r.name === x.description || r.label === x.description,
        );
        if (mailTemplate) {
          x.action = `r;${mailTemplate.id}`;
          return;
        }
      });
    });
  }
  vm.timeResources = [];
  vm.costResources = [];
  if (vm.hasTimeResources) {
    $http.get(`${appUrls.api}/api/Resource/Registration?type=0`).then(({ data }) => {
      vm.timeResources = data
        .map(x => ({
          id: x.id,
          name: resourceNameFilter(x),
          code: x.code || '',
        }))
        .sort(dynamicSortMultiple('code', 'name'));

      vm.model.timeResources.forEach(x => {
        if (x.originalId) {
          //Match by id, should only work if same tenant
          const resource = vm.timeResources.find(r => r.id === x.originalId);
          if (resource) {
            x.snippetImportId = resource.id;
            return;
          }
        }
        if (!x.description) return;
        //Match by name
        const resource = vm.timeResources.find(r => r.name === x.description);
        if (resource) {
          x.snippetImportId = resource.id;
          return;
        }
      });
    });
  }
  if (vm.hasCostResources) {
    $http.get(`${appUrls.api}/api/Resource/Registration?type=1`).then(({ data }) => {
      vm.costResources = data
        .map(x => ({
          id: x.id,
          name: resourceNameFilter(x),
          code: x.code || '',
        }))
        .sort(dynamicSortMultiple('code', 'name'));
      vm.model.costResources.forEach(x => {
        if (x.originalId) {
          //Match by id, should only work if same tenant
          const resource = vm.costResources.find(r => r.id === x.originalId);
          if (resource) {
            x.snippetImportId = resource.id;
            return;
          }
        }
        if (!x.description) return;
        //Match by name
        const resource = vm.costResources.find(r => r.name === x.description);
        if (resource) {
          x.snippetImportId = resource.id;
          return;
        }
      });
    });
  }

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };
  vm.isValid = function() {
    if (vm.form && vm.form.$invalid) return false;
    if (!vm.model.taskTemplateName) return false;
    if (vm.nameCheckError) return false;

    return true;
  };
  const showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = utils.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };
  vm.save = function() {
    if (vm.saving) return;
    if (!vm.isValid()) return;

    const model = {
      ...vm.model,
      mailTemplates: vm.mailTemplateActions
        .map(({ action, canImport, ...x }) => {
          if (!action) return null;
          if (canImport && action === 'import') return x;
          if (action.indexOf('r;') === 0) {
            return { ...x, snippetImportId: action.substr(2) };
          }
          return null;
        })
        .filter(x => !!x),
    };
    const hasNewMailTemplates = model.mailTemplates.some(x => !x.snippetImportId);
    vm.saving = true;
    return $http.post(appUrls.api + '/api/Snippet/Import/TaskTemplate', model).then(
      ({ data }) => {
        if (data && data.taskTemplateId) {
          $translate.refresh(); //reload translations
          return $http
            .get(`${appUrls.tasks}/api/TaskTemplates/Templates/${data.taskTemplateId}`)
            .then(
              ({ data }) => {
                $element.modal('hide');
                flySvc.success('msgConfirmChange');
                close([data, hasNewMailTemplates], 500);
                vm.saving = false;
              },
              error => {
                vm.saving = false;
                return showError(error);
              },
            );
        }
        vm.saving = false;
      },
      error => {
        vm.saving = false;
        return showError(error);
      },
    );
  };

  vm.nameCheckError = null;
  vm.checkNameCanceller = null;
  vm.checkName = function() {
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.checkNameCanceller) vm.checkNameCanceller.resolve();

    if (!vm.model.taskTemplateName) {
      vm.nameCheckError = null;
      return;
    }

    vm.checkNameCanceller = $q.defer();
    $http
      .get(`${appUrls.tasks}/api/TaskTemplates/CheckName`, {
        params: {
          name: vm.model.taskTemplateName,
        },
        timeout: vm.checkNameCanceller.promise,
      })
      .then(
        () => {
          //OK
          vm.nameCheckError = null;
        },
        ({ data }) => {
          vm.nameCheckError = flySvc.getErrorMsg(data.code, data.parameters, null, data.type);
        },
      );
  };
  vm.checkName();

  vm.cancel = function() {
    if (vm.data && vm.data.documentId) {
      //Cleanup temp document
      $http.delete(`${appUrls.documents}/api/documents/${vm.data.documentId}`);
    }
    $element.modal('hide');
    close(null, 500);
  };
}
